import { createSlice } from "@reduxjs/toolkit";
import { fetchConsultationReducer } from "../../reducer/consultation/fetchConsultationReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const consultationSlice = createSlice({
  name: "consultation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsultationReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchConsultationReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        console.log("action.payload:", action.payload);
      })
      .addCase(fetchConsultationReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadConsultationData");
      });
  },
});

export default consultationSlice.reducer;
